import { getPriceList, GetPriceListParams } from "@/http/catalogApi";
import { getPriceListQueryKey } from "@/utils/queryKeys";
import { useQuery } from "@tanstack/react-query";

export const useGetPriceListQuery = (params: GetPriceListParams) => {
  return useQuery({
    queryKey: getPriceListQueryKey(params.club_id),
    queryFn: () => getPriceList(params),
    select: (response) => response.data.data,
    enabled: !!params.club_id,
  });
};
